import { addNotification } from "../../notification/Notificationstore";
import { _ } from "svelte-i18n";
import { get } from "svelte/store";
export async function uploadFile(file, fileName, maxFileSize, getUploadLink, confirmFunction, sucessCallback, failedCallback) {
    //First get the link we need for S3
    const uploadLink = await getUploadLink();
    if (file) {
        if (file.size >= maxFileSize) {
            //Check for a to big attachment
            addNotification({
                type: "error",
                message: get(_)("documentview.attachments.err_attachment_size"),
            });
            //Inform the target
            failedCallback();
            return;
        }
        let formData = new FormData();
        // add all entries from uploadLink to formData
        for (let key in uploadLink.dataMap) {
            formData.append(key, uploadLink.dataMap[key]);
        }
        formData.append("file", file);
        let response = await fetch(uploadLink.url, {
            method: "POST",
            body: formData,
        });
        if (response.ok) {
            if (fileName == null && file instanceof File) {
                //Set the upload name to the file name
                fileName = file.name;
            }
            //Let the server know that we have uploaded a file.
            await confirmFunction(fileName || "", uploadLink.name);
            //Finish
            sucessCallback();
        }
        else {
            //Inform the user
            addNotification({
                type: "error",
                message: get(_)("general.import.err_file_upload"),
            });
            //Finish
            failedCallback();
        }
    }
}
